import { FC } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import PurchaseCsvExportItem, {
  PurchaseCsvColumn
} from './PurchaseCsvExportItem'

const COLUMNS: PurchaseCsvColumn[] = [
  { header: 'Empresa - Codigo', field: 'empresaCodigo' },
  { header: 'Usuario - Email', field: 'usuarioEmail' },
  { header: 'Fornecedor - Codigo', field: 'fornecedorCodigo' },
  { header: 'Fornecedor - Nome', field: 'fornecedorNome' },
  { header: 'CategoriaCompacta - Codigo', field: 'categoriaCompactaCodigo' },
  { header: 'CategoriaCompacta - Nome', field: 'categoriaCompactaNome' }
]

const ActionExcelPurchaseUserExport: FC = () => {
  const { dataUser = [], companieId } = useParametrizationConfigPurchase()

  // Uma linha por associação real fornecedor x categoria do comprador
  // (antes: produto cartesiano das listas, que inventava combinações)
  const getRows = () =>
    dataUser.flatMap(user =>
      (user.associacoes ?? []).map((assoc: any) => ({
        empresaCodigo: assoc.empresaId ?? companieId,
        // Sem e-mail no registro: fica vazio (não usa o e-mail de quem exporta)
        usuarioEmail: user['user-nome'] ?? '',
        fornecedorCodigo: assoc.fornecedorId,
        fornecedorNome: assoc.fornecedorNome,
        categoriaCompactaCodigo: assoc.categoriaCompactaId,
        categoriaCompactaNome: assoc.categoriaCompactaNome
      }))
    )

  return (
    <PurchaseCsvExportItem
      filenamePrefix="compradores"
      columns={COLUMNS}
      getRows={getRows}
      rowCount={dataUser.length}
    />
  )
}

export default ActionExcelPurchaseUserExport
